import {
    HOME_PAGE_URL,
    ABOUT_PAGE_URL,
    LINKS_PAGE_URL,
    CLIPS_FANSITES_PAGE_URL,
    GALLERY_PAGE_URL,
    DOMINATION_PAGE_URL,
    WRESTLING_PAGE_URL,
    SPLOSHING_PAGE_URL,
    POLICIES_PAGE_URL,
  } from '../Constants';
  
  export const FooterLinksArray = [
      { name: 'Home', route: HOME_PAGE_URL },
      { name: 'About Me', route: ABOUT_PAGE_URL },
      { name: 'Links', route: LINKS_PAGE_URL },
      { name: 'Clips & Fansites', route: CLIPS_FANSITES_PAGE_URL },
      { name: 'Gallery', route: GALLERY_PAGE_URL },
      { name: 'Domination', route: DOMINATION_PAGE_URL },
      { name: 'Wrestling', route: WRESTLING_PAGE_URL },
      { name: 'Sploshing', route: SPLOSHING_PAGE_URL },
      { name: 'Terms & Privacy', route: POLICIES_PAGE_URL },
  ];
  